import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > window.innerHeight); // Show after 100vh
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <Button
            onClick={scrollToTop}
            style={{
                position: "fixed",
                bottom: isVisible ? "30px" : "-60px", // Slide up & down
                right: "20px",
                opacity: isVisible ? 1 : 0, // Fade effect
                visibility: isVisible ? "visible" : "hidden",
                transition: "opacity 0.5s ease, bottom 0.5s ease",
                zIndex: 1000,
                borderRadius: "50%",
                width: "45px",
                height: "45px",
                background: "#0056b3",
                border: "none",
                color: "white",
                fontSize: "20px",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",

            }}
            onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
            }}
        >
            <FaArrowUp />
        </Button>
    );
};

export default ScrollToTopButton;
